const calcDiameterFromAngle = (distance, angle) => distance * Math.tan(angle) * 2;

export default calcDiameterFromAngle;
